import styled from '@emotion/styled';
import {
  CommonText,
  CommonBG,
  TableBG,
  SecondColor,
  StatusConfirmColor,
  StatusWarningMinorColor,
  StatusDoneColor,
  StatusErrorColor,
  LightBlueColor,
  DeepBlueColor,
  LimeColor,
  PinkColor,
  InfoText,
  CommonBorder,
  ControlLinedBG,
  InfoBG,
  InfoBorder,
  LegendStatusBG,
  LegendStatusBorder,
  LegendBasicBG,
  ControlFilldBG,
  InputBorder,
  ControlLinedBorder,
} from 'ui/theme/Color';
import { SVGIcon } from 'components/buttons/IconSVG';
import { TableBorder } from 'ui/theme/Color';

export const ContentGrid = styled.div`
  width: 100%;
  position: relative;

  --ag-foreground-color: ${CommonText.Basic};
  --ag-background-color: ${CommonBG.Basic};
  --ag-header-foreground-color: ${CommonText.Basic};
  --ag-header-background-color: ${TableBG.Header};
  --ag-border-color: ${TableBorder.Header};
  --ag-header-background-color: ${TableBG.Header};
  --ag-odd-row-background-color: ${TableBG.CellOdd};
  --ag-row-hover-color: ${TableBorder.Cell};
  --ag-row-border-color: ${CommonBorder.Bright};
  --ag-data-color: ${CommonText.Basic};
  --ag-header-column-separator-display: none;
  --ag-header-column-resize-handle-display: none;
  --ag-font-size: 13px;
  --ag-font-family: 'Malgun Gothic', 'Segoe UI', 'MS YaHei', Sans-Serif;
  --ag-alpine-active-color: ${TableBorder.CellFocus};
  --ag-selected-row-background-color: ${SecondColor.Second50};
  --ag-row-hover: ${CommonBG.Deeper};
  --ag-range-selection-border-color: ${TableBorder.CellFocus};
  --ag-input-focus-border-color: transparent !important;
  --ag-input-focus-box-shadow: transparent !important;

  --ag-checkbox-background-color: ${CommonBG.Basic};
  --ag-checkbox-unchecked-color: ${CommonBorder.Strong};
  --ag-checkbox-checked-color: ${CommonBG.Secondary};
  --ag-checkbox-indeterminate-color: ${CommonBG.Secondary};

  --ag-header-height: 32px;

  .ag-root-wrapper {
    a:link,
    a:visited,
    a:active,
    a:hover {
      text-decoration: underline !important;
      color: ${CommonText.Primary} !important;
      text-underline-position: under;
    }
  }

  .ag-icon-filter {
    &:before {
      content: '' !important;
    }
  }

  .ag-icon-asc {
    width: 12px;
    height: 12px;
    position: relative;
    &::before {
      content: '';
      clear: both;
      display: inline-block;
      width: 12px;
      height: 12px;
      position: absolute;
      top: 0;
      left: 0;
      background: ${CommonText.Light};
      -webkit-mask: ${SVGIcon.IcoSorting};
      mask-image: ${SVGIcon.IcoSorting};
    }
  }

  .ag-icon-desc {
    width: 12px;
    height: 12px;
    position: relative;
    &::before {
      content: '';
      clear: both;
      display: inline-block;
      width: 12px;
      height: 12px;
      position: absolute;
      top: 0;
      left: 0;
      transform: rotate(180deg);
      background: ${CommonText.Light};
      -webkit-mask: ${SVGIcon.IcoSorting};
      mask-image: ${SVGIcon.IcoSorting};
    }
  }

  .ag-icon-menu {
    width: 14px;
    height: 14px;
    position: relative;
    &::before {
      content: '';
      clear: both;
      display: inline-block;
      width: 12px;
      height: 12px;
      position: absolute;
      top: 1px;
      left: 1px;
      background: ${CommonText.Light};
      -webkit-mask: ${SVGIcon.IcoFiter};
      mask-image: ${SVGIcon.IcoFiter};
    }
  }

  .ag-cell-edit-wrapper {
    .ag-date-field-input-wrapper {
      background: #f1fdf7;
      input[ref='eInput'] {
        background: #f1fdf7;
      }
    }
    .ag-input-wrapper.ag-text-field-input-wrapper {
      input[ref='eInput'] {
        background: #f1fdf7;
      }
    }
  }

  .ag-row-selected {
    background: ${TableBG.CellSelected} !important;
  }

  .ag-theme-alpine .ag-menu {
    background: ${CommonBG.Basic};
    border: 1px solid ${CommonBorder.Strong};
    border-radius: 3px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.22), 0 7px 10px rgba(0, 0, 0, 0.12) !important;
  }

  .ag-menu:not(.ag-tabs) .ag-filter .ag-simple-filter-body-wrapper {
    min-width: 150px !important;
    max-width: 240px !important;
    max-height: 360px !important;
    padding: 10px !important;
  }

  .ag-picker-field-wrapper {
    border-radius: 2px !important;
  }

  .ag-popup-editor {
    background: ${CommonBG.Elevation};
    border-radius: 2px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.17), 0 4px 5px rgba(0, 0, 0, 0.11) !important;
    padding: 8px !important;
    .ag-large-text-input {
      padding: 0px !important;
    }
    textarea {
      border: 1px solid ${CommonBorder.Strong} !important;
      border-radius: 2px;
      &:focus {
        border-color: ${InputBorder.Focus} !important;
      }
    }
  }

  .ag-has-popup-positioned-under {
    .ag-icon-menu {
      width: 14px;
      height: 14px;
      position: relative;
      &::before {
        content: '';
        clear: both;
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 0;
        left: 0;
        background: ${ControlFilldBG.InversActive};
        -webkit-mask: ${SVGIcon.IcoFilterOn};
        mask-image: ${SVGIcon.IcoFilterOn};
      }
    }
  }

  .ag-filter-body {
    margin-bottom: 0px !important;
  }

  .ag-text-field-input {
    height: 32px;
    border-radius: 2px;
    border: 1px solid ${CommonBorder.Strong};
    &:focus {
      border-color: ${InputBorder.Focus} !important;
    }
  }

  input[class^='ag-'][type='text']:focus {
    border-color: ${InputBorder.Focus} !important;
  }

  .ag-picker-field-wrapper {
    height: 32px;
    border: 1px solid ${CommonBorder.Strong};
  }

  .ag-header-cell.ag-focus-managed {
    border-right: 1px solid ${CommonBorder.Basic};
    /* padding:0px 10px !important; */
    border-top: none;
    border-left: none;
    border-bottom: none;
  }

  .ag-picker-field-display {
    color: ${CommonBorder.Strong};
    font-size: 13px !important;
    font-weight: 400 !important;
  }

  .ag-icon-small-down {
    position: relative;
    &:before {
      content: '' !important;
      clear: both;
      display: inline-block;
      position: absolute;
      width: 10px;
      height: 10px;
      top: 50%;
      right: 11px;
      transform: translateY(-50%);
      background: ${ControlFilldBG.BasicActive};
      -webkit-mask: ${SVGIcon.IcoSelect};
      mask-image: ${SVGIcon.IcoSelect};
    }
  }

  .ag-filter-condition {
    height: 36px;
    padding: 8px 0px;
    margin-bottom: 0px !important;
  }

  .ag-label-align-right .ag-label {
    margin-left: 4px !important;
    font-size: 13px;
    font-weight: 400;
    color: ${CommonText.Basic};
  }

  .ag-radio-button-input-wrapper {
    cursor: pointer;
    &:after {
      content: '' !important;
      clear: both;
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 8px;
      background: ${CommonBG.Elevation};
      border: 1px solid ${CommonBorder.Strong};
    }
  }

  .ag-radio-button-input-wrapper.ag-disabled {
    cursor: default;
    opacity: 0.4 !important;
    &:after {
      content: '' !important;
      clear: both;
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 8px;
      background: ${CommonBG.Elevation};
      border: 1px solid ${CommonBG.Elevation};
    }
  }

  .ag-radio-button-input-wrapper.ag-checked.ag-disabled {
    cursor: default;
    opacity: 0.4 !important;
    &:after {
      content: '' !important;
      clear: both;
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 8px;
      background: ${CommonBG.Elevation};
      border: 4px solid ${CommonBorder.Primary};
    }
  }

  .ag-radio-button-input-wrapper.ag-checked {
    &:after {
      content: '' !important;
      clear: both;
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 8px;
      background: ${CommonBG.Elevation};
      border: 4px solid ${CommonBorder.Primary};
    }
  }

  .ag-header-group-cell.ag-header-group-cell-with-group {
    border-right: 1px solid ${TableBorder.Header};
    border-bottom: 1px solid ${TableBorder.Header};
  }

  .ag-header-row.ag-header-row-column {
    width: 100% !important;
  }

  .cellStatus {
    padding: 0px !important;
    text-align: center;
  }

  .ag-header-cell {
    padding: 0px !important;
    text-align: center;
  }

  div[ref='eCheckbox'].ag-checkbox {
    margin: 0 auto;
  }

  .ag-ltr {
    .ag-header-select-all {
      margin: 0px auto !important;
    }
  }

  .ag-ltr {
    .ag-selection-checkbox {
      margin: 0px !important;
    }
  }

  .ag-header-cell-text,
  .ag-header-group-text {
    display: block;
    margin: 0 auto;
    text-align: center;
    overflow: visible;
    text-overflow: initial;
  }

  .ag-header-group-cell-label.ag-sticky-label {
    margin: 0 auto;
  }

  .ag-header-cell.ag-focus-managed[aria-colindex='1'] {
    border-right: 1px solid ${TableBorder.Header};
    /* padding: 0px 10px !important; */
  }

  .ag-theme-alpine,
  .ag-header-row {
    font-weight: 400;
  }

  .ag-theme-alpine,
  .ag-row {
    font-size: 13px !important;
  }

  .ag-row-position-absolute {
    z-index: 990 !important;
  }

  .ag-cell {
    border: none;
  }

  .ag-cell-label-container {
    padding: 0px !important;
  }

  .ag-cell-focus:not(.ag-cell-range-selected):focus-within {
    background: ${SecondColor.Second50};
  }

  .ag-cell.ag-cell-value {
    border-right: 1px solid ${TableBorder.Cell};
  }

  .ag-cell-inline-editing {
    border-color: ${TableBorder.CellFocus};
    background: ${TableBG.CellSelected} !important;
    border-radius: 0px !important;
    box-shadow: none !important;
  }

  .ag-cell-focus:not(.ag-cell-range-selected):focus-within {
    background: none;
  }

  .ag-center-cols-viewport {
    min-height: unset !important;
  }

  .ag-checkbox-input-wrapper:focus-within {
    box-shadow: none !important;
  }

  .ag-paging-panel.ag-unselectable {
    height: 32px;
    border-top-color: ${CommonBorder.Bright};
  }

  .ag-paging-panel {
    justify-content: center;
  }

  &.noScrol {
    .ag-body-horizontal-scroll {
      display: none;
      height: 0;
    }
  }
  .ag-cell-normal-height.ag-cell-value {
    .ag-cell-wrapper {
      height: 100%;
    }
  }

  .ag-overlay {
    position: initial;
    .ag-overlay-panel {
      .ag-overlay-wrapper {
        .agNodata {
          width: 100%;
          height: 100%;
          background: ${CommonBG.Deep};
          position: relative;
          span {
            display: inline-block;
            font-size: 15px;
            font-weight: bold;
            position: absolute;
            top: calc(50% - 12px);
            left: 50%;
            transform: translateX(-50%);
            color: ${CommonText.Lighter};
          }
          &:after {
            content: '';
            clear: both;
            display: inline-block;
            width: 56px;
            height: 56px;
            position: absolute;
            top: calc(50% - 80px);
            left: 50%;
            transform: translateX(-50%);
            background-image: url("data:image/svg+xml,%3Csvg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M39.3105 27.6056C39.1961 31.7178 37.6349 35.4683 35.1178 38.3663L45.018 48.2665C45.491 48.7395 45.491 49.5064 45.018 49.9794C44.545 50.4524 43.7781 50.4524 43.3051 49.9794L33.4048 40.0791C30.3932 42.6949 26.4608 44.2782 22.1586 44.2782C12.6822 44.2782 5 36.596 5 27.1196C5 17.6431 12.6822 9.96094 22.1586 9.96094C24.5429 9.96094 26.8135 10.4472 28.8768 11.326C28.5228 12.0466 28.2432 12.8104 28.0481 13.6073C26.2444 12.82 24.2525 12.3833 22.1586 12.3833C14.02 12.3833 7.42239 18.981 7.42239 27.1196C7.42239 35.2582 14.02 41.8558 22.1586 41.8558C30.2011 41.8558 36.7388 35.4131 36.8921 27.4073C37.5842 27.5397 38.2985 27.609 39.0289 27.609C39.123 27.609 39.2169 27.6079 39.3105 27.6056Z' fill='%23DDE0DF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M39.0289 25.5327C44.1255 25.5327 48.257 21.4011 48.257 16.3045C48.257 11.2079 44.1255 7.07634 39.0289 7.07634C33.9323 7.07634 29.8007 11.2079 29.8007 16.3045C29.8007 17.6424 30.0844 18.9095 30.5932 20.0526C30.907 20.7577 31.0308 21.6074 30.8021 22.4608L30.0443 25.2889L32.8722 24.5312C33.7257 24.3025 34.5755 24.4263 35.2805 24.7401C36.4237 25.249 37.6908 25.5327 39.0289 25.5327ZM50.3334 16.3045C50.3334 22.5478 45.2722 27.609 39.0289 27.609C37.3943 27.609 35.84 27.2619 34.4362 26.637C34.1024 26.4884 33.741 26.448 33.4096 26.5368L29.6167 27.5531C28.5017 27.8518 27.4814 26.8315 27.7801 25.7165L28.7965 21.9234C28.8853 21.5921 28.8448 21.2307 28.6962 20.8969C28.0714 19.4932 27.7244 17.9389 27.7244 16.3045C27.7244 10.0612 32.7856 5 39.0289 5C45.2722 5 50.3334 10.0612 50.3334 16.3045ZM40.5285 16.3045C40.5285 17.1327 39.8571 17.8041 39.0289 17.8041C38.2007 17.8041 37.5293 17.1327 37.5293 16.3045C37.5293 15.4763 38.2007 14.8049 39.0289 14.8049C39.8571 14.8049 40.5285 15.4763 40.5285 16.3045ZM45.1425 16.3045C45.1425 17.1327 44.4712 17.8041 43.643 17.8041C42.8148 17.8041 42.1434 17.1327 42.1434 16.3045C42.1434 15.4763 42.8148 14.8049 43.643 14.8049C44.4712 14.8049 45.1425 15.4763 45.1425 16.3045ZM35.9144 16.3045C35.9144 17.1327 35.243 17.8041 34.4148 17.8041C33.5866 17.8041 32.9152 17.1327 32.9152 16.3045C32.9152 15.4763 33.5866 14.8049 34.4148 14.8049C35.243 14.8049 35.9144 15.4763 35.9144 16.3045Z' fill='%23DDE0DF'/%3E%3C/svg%3E%0A");
          }
        }
      }
    }
  }

  .ag-popup {
    .ag-popup-editor,
    .ag-popup-child {
      z-index: 999;
    }
  }

  // Custom Class

  .cellTooltip {
    background: ${CommonBG.Inverse};
    color: ${CommonText.Inverse};
    font-size: 12px;
    line-height: 1.5;
    white-space: nowrap;
    padding: 12px;
    border-radius: 2px;
  }

  .cellEditing {
    background: #f1fdf7 !important;
    padding: 0px 8px 4x 8px;
    &:before {
      content: '';
      clear: both;
      display: inline-block;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 4px;
      height: 4px;
      z-index: 999;
      border-top: 2px solid ${CommonBG.Secondary};
      border-right: 2px solid transparent;
      border-bottom: 2px solid transparent;
      border-left: 2px solid ${CommonBG.Secondary};
    }
    input {
      border: none !important;
      &:focus {
        border-radius: 0px !important;
      }
    }
  }

  .headerCheck {
    border-right: 1px solid ${TableBorder.Cell};
    padding: 0px !important;
    border-top: none;
    border-left: none;
    border-bottom: none;
    & > .ag-header-cell-comp-wrapper {
      display: none !important;
    }
    &.disable {
      .ag-input-wrapper {
        opacity: 0.4;
      }
      input[type='checkbox'] {
        pointer-events: none;
      }
    }
  }

  .cellCheck {
    border-right: 1px solid ${TableBorder.Cell} !important;
    padding: 0px !important;
    border-top: none;
    border-left: none;
    border-bottom: none;
    .ag-cell-wrapper {
      display: block !important;
    }
  }

  .cellSelect {
    padding: 0px !important;
    background: #f1fdf7;
    &:before {
      content: '';
      clear: both;
      display: inline-block;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 4px;
      height: 4px;
      z-index: 999;
      border-top: 2px solid ${CommonBG.Secondary};
      border-right: 2px solid transparent;
      border-bottom: 2px solid transparent;
      border-left: 2px solid ${CommonBG.Secondary};
    }
    .MuiFormControl-root {
      width: 100%;
      height: 31px !important;
      &:focus,
      &:active {
        border-color: ${CommonBorder.Secondary} !important;
        background: ${TableBG.CellSelected} !important;
      }
    }
    div.Mui-focused {
      border: 1px solid ${CommonBorder.Secondary} !important;
      background: ${TableBG.CellSelected} !important;
    }
    .MuiInputBase-root {
      border-radius: 0px !important;
      width: 100%;
      height: 31px !important;
      font-family: 'Malgun Gothic', 'Segoe UI', 'MS YaHei', sans-serif;
      font-size: 13px !important;
      font-weight: 400;
      line-height: 1.5;
      color: ${CommonText.Basic};
      div[aria-haspopup='listbox'] {
        padding: 0px 5px 0px 12px;
        box-sizing: border-box;
      }
      svg {
        width: 10px;
        height: 10px;
        top: calc(50% - 5px);
        background: ${CommonText.Light};
        -webkit-mask: ${SVGIcon.IcoSelect};
        mask-image: ${SVGIcon.IcoSelect};
        path {
          display: none;
        }
      }
    }
    .MuiSelect-select {
      padding: 0px;
      min-height: 31px !important;
      border-radius: 0px !important;
      line-height: 33px;
    }
    .MuiSelect-nativeInput {
      height: 31px;
    }
    fieldset {
      border: none !important;
      top: 0px !important;
      height: 31px;
      padding: 0px 12px !important;
      &:focus {
        outline: none !important;
      }
    }
    label {
      display: block;
      font-size: 13px;
      font-weight: 400;
      line-height: 33px;
      height: 31px;
      color: ${CommonText.Lighter} !important;
      transform-origin: initial;
      transform: none;
      -webkit-transform: none;
      width: calc(100% - 24px);
      padding: 0px 5px 0px 12px;
      font-family: 'Malgun Gothic', 'Segoe UI', 'MS YaHei', sans-serif;
      &[data-shrink='true'] {
        display: none;
      }
    }
  }
  .ag-checkbox.ag-input-field {
    width: 16px;
    height: 16px;
    .ag-wrapper.ag-input-wrapper {
      border-radius: 2px;
      border: 1px solid ${CommonBorder.Strong};
      box-shadow: none;
      &.ag-checked {
        border: 1px solid ${SecondColor.Second500};
        background-color: ${SecondColor.Second500};
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.6343 5.23431C11.9467 4.9219 12.4533 4.9219 12.7657 5.23431C13.0781 5.54673 13.0781 6.05327 12.7657 6.36568L7.4217 11.7097C6.81646 12.3149 5.8352 12.315 5.22986 11.7099L2.23441 8.71548C1.92194 8.40311 1.92185 7.89658 2.23422 7.58411C2.54658 7.27163 3.05311 7.27154 3.36559 7.58391L6.32567 10.543L11.6343 5.23431Z' fill='white'/%3E%3C/svg%3E%0A");
        background-size: 14px 14px;
        background-position: center;
        background-repeat: no-repeat;
      }
      &:after {
        content: '';
        color: inherit;
      }
      &.ag-indeterminate {
        border: 1px solid ${SecondColor.Second500};
        background-color: ${SecondColor.Second500};
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='7' width='8' height='2' rx='1' fill='white'/%3E%3C/svg%3E%0A");
        background-size: 14px 14px;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }

  .wj-flexgrid {
    & + div.noData {
      display: none;
    }
  }

  &.noData {
    .wj-flexgrid,
    .wj-multirow {
      position: relative;
      div[wj-part='root'] {
        &::-webkit-scrollbar {
          display: none;
        }
      }
      & + div.noData {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: -8px;
        height: 260px;
        background: ${CommonBG.Deep};
        border: 1px solid ${CommonText.Bright};
        position: relative;
        span {
          display: block;
          font-size: 15px;
          font-weight: bold;
          position: relative;
          color: ${CommonText.Lighter};
          &:after {
            content: '';
            clear: both;
            display: inline-block;
            width: 56px;
            height: 56px;
            position: absolute;
            top: -56px;
            left: 50%;
            transform: translateX(-50%);
            background-image: url("data:image/svg+xml,%3Csvg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M39.3105 27.6056C39.1961 31.7178 37.6349 35.4683 35.1178 38.3663L45.018 48.2665C45.491 48.7395 45.491 49.5064 45.018 49.9794C44.545 50.4524 43.7781 50.4524 43.3051 49.9794L33.4048 40.0791C30.3932 42.6949 26.4608 44.2782 22.1586 44.2782C12.6822 44.2782 5 36.596 5 27.1196C5 17.6431 12.6822 9.96094 22.1586 9.96094C24.5429 9.96094 26.8135 10.4472 28.8768 11.326C28.5228 12.0466 28.2432 12.8104 28.0481 13.6073C26.2444 12.82 24.2525 12.3833 22.1586 12.3833C14.02 12.3833 7.42239 18.981 7.42239 27.1196C7.42239 35.2582 14.02 41.8558 22.1586 41.8558C30.2011 41.8558 36.7388 35.4131 36.8921 27.4073C37.5842 27.5397 38.2985 27.609 39.0289 27.609C39.123 27.609 39.2169 27.6079 39.3105 27.6056Z' fill='%23DDE0DF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M39.0289 25.5327C44.1255 25.5327 48.257 21.4011 48.257 16.3045C48.257 11.2079 44.1255 7.07634 39.0289 7.07634C33.9323 7.07634 29.8007 11.2079 29.8007 16.3045C29.8007 17.6424 30.0844 18.9095 30.5932 20.0526C30.907 20.7577 31.0308 21.6074 30.8021 22.4608L30.0443 25.2889L32.8722 24.5312C33.7257 24.3025 34.5755 24.4263 35.2805 24.7401C36.4237 25.249 37.6908 25.5327 39.0289 25.5327ZM50.3334 16.3045C50.3334 22.5478 45.2722 27.609 39.0289 27.609C37.3943 27.609 35.84 27.2619 34.4362 26.637C34.1024 26.4884 33.741 26.448 33.4096 26.5368L29.6167 27.5531C28.5017 27.8518 27.4814 26.8315 27.7801 25.7165L28.7965 21.9234C28.8853 21.5921 28.8448 21.2307 28.6962 20.8969C28.0714 19.4932 27.7244 17.9389 27.7244 16.3045C27.7244 10.0612 32.7856 5 39.0289 5C45.2722 5 50.3334 10.0612 50.3334 16.3045ZM40.5285 16.3045C40.5285 17.1327 39.8571 17.8041 39.0289 17.8041C38.2007 17.8041 37.5293 17.1327 37.5293 16.3045C37.5293 15.4763 38.2007 14.8049 39.0289 14.8049C39.8571 14.8049 40.5285 15.4763 40.5285 16.3045ZM45.1425 16.3045C45.1425 17.1327 44.4712 17.8041 43.643 17.8041C42.8148 17.8041 42.1434 17.1327 42.1434 16.3045C42.1434 15.4763 42.8148 14.8049 43.643 14.8049C44.4712 14.8049 45.1425 15.4763 45.1425 16.3045ZM35.9144 16.3045C35.9144 17.1327 35.243 17.8041 34.4148 17.8041C33.5866 17.8041 32.9152 17.1327 32.9152 16.3045C32.9152 15.4763 33.5866 14.8049 34.4148 14.8049C35.243 14.8049 35.9144 15.4763 35.9144 16.3045Z' fill='%23DDE0DF'/%3E%3C/svg%3E%0A");
          }
        }
      }
    }
  }
`;
